import { render, staticRenderFns } from "./SharedProduct.vue?vue&type=template&id=4b8cd7ff&"
import script from "./SharedProduct.vue?vue&type=script&lang=js&"
export * from "./SharedProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports